import { useMemo, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Button, Text } from 'ui'
import { WorkersSelector } from 'components/WorkersSelector'
import { SelectedRSW } from './SelectedRSW'
import { useShiftEditor } from 'pages/ShiftEditorPage/useShiftEditor'
import { EditorMode } from 'pages/ShiftEditorPage/ShiftEditorProvider'
import { useHypotheticalShifts } from 'hooks/useHypotheticalShifts'
import { SelectedWorkerStatus } from 'components/WorkersSelector/SelectedWorkerStatus'

export function RSW() {
  const { editorMode, editData, isOnDemandDeliveryBlock } = useShiftEditor()
  const { control, watch } = useFormContext()
  const [open, setOpen] = useState(false)
  const specificWorkers = watch('specificWorkers')
  const hasSelectedWorkers = (specificWorkers ?? []).length > 0
  const hypotheticalShifts = useHypotheticalShifts()

  const defaultText = useMemo(() => {
    if (isOnDemandDeliveryBlock) {
      if (editorMode === EditorMode.PastShift) {
        return 'Your chosen delivery drivers will be assigned to this shift.'
      }
      return 'A text message will be sent to your chosen delivery drivers, inviting them to accept this shift.'
    }

    if (editorMode === EditorMode.PastShift) {
      return 'Your chosen workers will be assigned to this shift.'
    }

    return 'A text message will be sent to your chosen workers, inviting them to accept this shift.'
  }, [isOnDemandDeliveryBlock, editorMode])
  return (
    <Box>
      <Text my={2} mb={3}>
        {defaultText}
      </Text>
      {!hasSelectedWorkers ? (
        <Button width={[1, 200]} onClick={() => setOpen(true)}>
          {isOnDemandDeliveryBlock ? 'Add Delivery Drivers' : 'Add Workers'}
        </Button>
      ) : null}
      <SelectedRSW openSelector={() => setOpen(true)} />
      <Controller
        render={({ field: { value, onChange } }) => (
          <WorkersSelector
            open={open}
            onClose={() => setOpen(false)}
            selected={value}
            onChange={(selected) => {
              onChange(selected)
              setOpen(false)
            }}
            selectedWorkerStatusComponent={(worker) => {
              return editorMode !== EditorMode.PastShift ? (
                <SelectedWorkerStatus
                  worker={worker}
                  hypotheticalShifts={hypotheticalShifts}
                  existingShift={editData}
                />
              ) : null
            }}
          />
        )}
        name={'specificWorkers'}
        control={control}
      />
    </Box>
  )
}
